// import { throttle } from 'lodash';
export class MouseWheelHandler {

    /**
     * Gets the average of the last `number` elements of the given array.
     */
    // private static getAverage(elements: number[], num: number) {
    //     let sum = 0;

    //     // taking `number` elements from the end to make the average, if there are not enought, 1
    //     const lastElements = elements.slice(Math.max(elements.length - num, 1));

    //     lastElements.forEach(value => sum += value)

    //     return Math.ceil(sum / lastElements.length);
    // }
    private prevScroll = new Date().getTime();
    private prevTime = new Date().getTime();
    private prevValue = 0;

    // private scrollings: number[] = [];
    // private prevScroll: number = 0;
    private up: () => void;

    private down: () => void;
    constructor(up: () => void, down: () => void) {
        this.handler = this.handler.bind(this);
        this.up = up;
        this.down = down;
    }
    public listen() {
        let prefix = '';
        let addEventListenerName;

        if (window.addEventListener) {
            addEventListenerName = "addEventListener";
        } else {
            addEventListenerName = "attachEvent";
            prefix = 'on';
        }

        // detect available wheel event
        const support = 'onwheel' in document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
            // tslint:disable-next-line:no-string-literal
            document["onmousewheel"] !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
                'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox

        if (support === 'DOMMouseScroll') {
            document[addEventListenerName](prefix + 'MozMousePixelScroll', this.handler, false);
        }

        // handle MozMousePixelScroll in older Firefox
        else {
            document[addEventListenerName](prefix + support, this.handler, false);
        }
    }

    public unlisten() {

        if (document.addEventListener) {
            document.removeEventListener('mousewheel', this.handler, false); // IE9, Chrome, Safari, Oper
            document.removeEventListener('wheel', this.handler, false); // Firefox
            document.removeEventListener('MozMousePixelScroll', this.handler, false); // old Firefox
        } else {
            // tslint:disable-next-line:no-string-literal
            document["detachEvent"]('onmousewheel', this.handler); // IE 6/7/8
        }

    }
    private handler(e: MouseWheelEvent) {

        // cross-browser wheel delta
        e = e || window.event;
        const value = e.wheelDelta || -e.deltaY || -e.detail;
        const delta = Math.max(-1, Math.min(1, value));

        const horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
        const isScrollingVertically = (Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta)) ||
            (Math.abs(e.deltaX) < Math.abs(e.deltaY) || !horizontalDetection);

        // // Limiting the array to 150 (lets not waste memory!)
        // if (this.scrollings.length > 149) {
        //     this.scrollings.shift();
        // }

        if (!isScrollingVertically) {
            return false;
        }
        const curTime = new Date().getTime();

        // time difference between the last scroll and the current one
        const timeDiffScroll = curTime - this.prevScroll;

        // time difference between the last scroll and the current one
        const timeDiffWheel = curTime - this.prevTime;
        this.prevTime = curTime;
        const isAccelerating = (Math.abs(this.prevValue) < Math.abs(value) && timeDiffScroll > 500);
        const isDirectionChange = (this.prevValue * value) < 0;
        const isDelayEnough = timeDiffWheel > 500;

        // const isFirst = this.scrollings.length === 1;
        this.prevValue = value;
        const isValid =
            (isDirectionChange ||
                isDelayEnough ||
                isAccelerating
            );

        // to avoid double swipes...
        if (isValid) {
            this.prevScroll = curTime;
            if (delta < 0) {
                this.down();
                // scrolling up?
            } else {
                this.up();
            }
        }
        e.preventDefault();
        // this.prevScroll = value;
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/MouseWheelHandler.ts